import '@babel/polyfill';
// Transpiler for older browsers
import 'core-js/stable';
// optional but required for transforming generator fns.
import 'regenerator-runtime/runtime';
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();

import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Home from './views/Home.vue'
import Secure from './components/Secure.vue'
import Login from './components/Login.vue'
import PreAuthentication from './components/PreAuthentication.vue'
import UploadRecordDictation from './components/UploadRecordDictation.vue'
Vue.use(Router)

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }, {
        path: '/chat',
        name: 'chat',
        component: () => import(/* webpackChunkName: "about" */ './examples/Chat.vue')
    }, {
        path: '/patientHistory',
        name: 'patientHistory',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ './components/PatientHistory.vue'),
        meta: {
            requiresAuth: true
        },
        props: true,
    }, {
        path: '/secure',
        name: 'secure',
        component: Secure,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/login',
        name: 'login',
        component: Login
    }, {
        path: '/preauthentication',
        name: 'PreAuthentication',
        component: PreAuthentication
    }, {
        path: '/uploadrecord',
        name: 'UploadRecordDictation',
        component: UploadRecordDictation
    }
    ]
})
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store && store.getters.isLoggedIn) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
})
export default router